<template>
  <div class="taskTemplateList">
    <el-card>
      <el-button type="primary" slot="header" @click="add">创建模板</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="name" label="模板名称"></el-table-column>
        <el-table-column prop="typeId1" label="一级分类"></el-table-column>
        <el-table-column prop="gardenStaffNames" label="责任人"></el-table-column>
        <el-table-column prop="patrolNames" label="巡检标准"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation"
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button v-if='scope.row.state === 0' @click="play(scope.row)">{{$t('lang.lab_taskPlay')}}</el-button>
            <el-button v-if='scope.row.state === 1' @click="pause(scope.row)">{{$t('lang.lab_taskPause')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
  /**
   *@ClassName:taskManageList
   *@Description:任务管理
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-04-26
   */
  export default {
    name: '/manage/main.quartzJobList',
    data() {
      return {
        gardenId: this.$store.getters.gardenId,
        multipleSelection: [], // 多选框
        gardenList: [], // 小区集合
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        tableData: [], // 列表数据
        statelist: this.$i18n.t('lang.TaskManageList_stateList'), // 状态
        taskManageListcheckbox: require('@/config/enum').taskManageListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      // 查询list
      this.getData()
    },
    activated() {
      // 查询list
      this.getData()
    },
    computed: {
      ...mapGetters({ userDataId: 'staffId', userGardenList: 'userGardenList' })
    },
    watch: {

    },
    methods: {
      // 获取数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `/quartzJobTemplate`).then(
          res => {
            console.log(res)
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 新增
      add() {
        window.localStorage.setItem('taskManagementForm', '')
        this.$router.push({
          name: 'taskTemplateAdd',
          query: {
            flag: false,
            isPatrol: 0
          }
        })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            this.$delete(`/quartzJobTemplate/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                if (error === null) {
                  this.$message.warning(this.$i18n.t('lang.lab_deleteError'))
                } else {
                  this.$message.error(error)
                }
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
        let selectArr = []
        val.forEach(element => {
          selectArr.push({ id: element.id, createPerson: element.createPerson })
        })
        this.selectArr = selectArr
        console.log(selectArr)
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .taskTemplateList {
    .blue {
      color: #4A88B0
    }
  }

  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
</style>
